import { provideEnvironmentInitializer, inject } from '@angular/core';
import { NotificationPermissionEnforcerService } from './notification-permission-enforcer.service';

/**
 * Provider that eagerly initializes the NotificationPermissionEnforcerService.
 * This ensures account managers are redirected to the notification permissions
 * page on every navigation if they haven't granted notification permissions.
 *
 * Usage:
 * ```typescript
 * export const applicationConfigProviders = [
 *   ...otherProviders,
 *   provideNotificationPermissionEnforcer(),
 * ];
 * ```
 */
export function provideNotificationPermissionEnforcer() {
  return provideEnvironmentInitializer(() => {
    inject(NotificationPermissionEnforcerService);
  });
}
